import React from 'react'
import { TableHeader } from '../../../commons'
import JobsTableBody from './JobsTableBody'
import { JobsTypeListType } from '../../../../commonTypes/jobsType'

const JOB_TYPE_HEADER = [
    { label: "Short Code", value: "short_code" },
    { label: "Job Type", value: "job_type" },
    { label: "Period Length", value: "period_length" },
    { label: "Next Period End", value: "next_period_end" },
    { label: "Create Job At", value: "create_job_at" },
    { label: "Target End Date", value: "target_end_date" },
    { label: "Updated By", value: "updated_by" },
    { label: "Status", value: "status" },
    { label: "Action", value: "action" },
]


type AppProps = {
    history: any;
    data: JobsTypeListType[] | [] ;
    isEditJobsTypePresent?:boolean;
    handleChangeStatus:(e:any,data:string)=>void;
    searchTerm:string;
    isViewChecklist:boolean;
}

const JobsTypeTable = ({ history, data , handleChangeStatus , isEditJobsTypePresent , searchTerm , isViewChecklist}: AppProps) => {
    return (
        <div className='jobsType' style={{ overflowX: "scroll" }}>
            <table className="table thead-light table-bordered">
                <thead className='sticky-table-header'>
                    <TableHeader
                        tableHeader={JOB_TYPE_HEADER}
                    />
                </thead>
                <tbody>
                    <JobsTableBody
                        data={data}
                        header={JOB_TYPE_HEADER}
                        history={history}
                        handleChangeStatus={handleChangeStatus}
                        isEditJobsTypePresent={isEditJobsTypePresent}
                        searchTerm={searchTerm}
                        isViewChecklist={isViewChecklist}
                    />
                </tbody>
            </table>
        </div>
    )
}

export default JobsTypeTable